import Papa from 'papaparse';
import AddLocation from '@material-ui/icons/AddLocation';
import { useRef, useState } from 'react';
import { Button, useDataProvider, useRefresh, useTranslate } from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import LocationOK from '@material-ui/icons/LocationOn'
import LocationNoGeometry from '@material-ui/icons/LocationOff'
import LocationNotRelated from '@material-ui/icons/LinkOff';
import LocationWARNING from '@material-ui/icons/Warning';
import LocationNotFound from '@material-ui/icons/NotListedLocation';
import { Row, Spacing } from '../../layout';
import Legend from '../Legend';
import { findOne, update } from '../../../../services/common/common';
import { filter, filterObject, filterValue } from '../../utils/fn';
import Loader from '../Loader';
import { Tooltip } from '@material-ui/core';
import { geojsonValid } from './GeometryField';

const GeometryImportButton = ({projectId}) => {
    const refresh = useRefresh();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const [loading, setLoading] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [addedTotal, setAddedTotal] = useState<number>();
    const [notJSONTotal, setNotJSONTotal] = useState<number>();
    const [noGeometryTotal, setNoGeometryTotal] = useState<number>();
    const [noRelatedAttributeTotal, setNoRelatedAttributeTotal] = useState<number>();
    const [notFoundTotal, setNotFoundTotal] = useState<number>();
    const fileInputRef = useRef(null);
    return <>
        <input 
            type="file" 
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={(event) => {
                const selectedFile = event.target.files[0];
                if (selectedFile) {
                    console.log('Selected file:', selectedFile);
                    setLoading(true);
                    Papa.parse(selectedFile, {
                        header: true,
                        complete: async(result) => {
                            let added=0;
                            let notJSON=0;
                            let noGeometry=0;
                            let noRelatedAttribute=0;
                            let notFound=0;
                            for (const row of result.data) {
                                let productionUnit;
                                if (row.geometry) {
                                    let hasAttributes = true;
                                    try {
                                        if (row.id) {
                                            productionUnit = await findOne(dataProvider, 'production_unit', {id:row.id, "lot":filter('project.id', projectId)});
                                        } else if (row.name) {
                                            if (row.lotId) {
                                                productionUnit = await findOne(dataProvider, 'production_unit', {name:row.name, lotId:parseInt(row.lotId, 10), "lot":filter('project.id', projectId)});
                                            } else if (row.lotName) {
                                                productionUnit = await findOne(dataProvider, 'production_unit', {name:row.name, "_and":filterValue([
                                                    filterObject('lot.project.id._eq', projectId),
                                                    filterObject('lot.name._eq', row.lotName)
                                                ])});
                                            } else {
                                                hasAttributes = false;
                                            }
                                        } else {
                                            hasAttributes = false;
                                        }
                                    } catch(e) {}
                                    if (hasAttributes) {
                                        console.log("productionUnit", productionUnit);
                                        if (productionUnit) {
                                            try {
                                                let geometry = row.geometry;
                                                // Ajouter des guillemets doubles autour des clés
                                                geometry = geometry.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2":');
                                                update(dataProvider, 'production_unit', productionUnit.id, {geometry}, productionUnit)
                                                added++;
                                                if (!geojsonValid(geometry)) {
                                                    notJSON++;
                                                }
                                            } catch(e) {
                                                notFound++;
                                            }
                                        } else {
                                            notFound++;
                                        }
                                    } else {
                                        noRelatedAttribute++;
                                    }
                                } else {
                                    noGeometry++;
                                }
                            };
                            setNoGeometryTotal(noGeometry);
                            setNoRelatedAttributeTotal(noRelatedAttribute);
                            setNotFoundTotal(notFound);
                            setNotJSONTotal(notJSON);
                            setAddedTotal(added);
                            fileInputRef.current.value = "";
                            refresh();
                            setLoading(false);
                            setOpen(true);
                        }
                    });
                }
            }}
            accept=".csv"
        />
        <Tooltip title={translate("resources.geometry.importTitle")}>
            <span className="importButtonGeo">
                <Button label={translate("resources.geometry.import")}   variant="contained" onClick={() => {
                    fileInputRef.current.click();
                }}><AddLocation /></Button>
            </span>
        </Tooltip>
        <Dialog open={loading} className="fullscreen">
            <Loader />
        </Dialog>
        <Dialog className="maxWidth" open={open}>
            <div className="summary">
                <Legend />
                {addedTotal > 0 && <div>
                        <LocationOK className="green" />
                        {translate("resources.geometry.summary.added", {smart_count:addedTotal})}
                    </div>}
                {notJSONTotal > 0 && <div className="indent">
                        <LocationWARNING color="error" />
                        {translate("resources.geometry.summary.notJSON", {smart_count:notJSONTotal})}
                    </div>}
                {noGeometryTotal > 0 && <div>
                        <LocationNoGeometry color="disabled" />
                        {translate("resources.geometry.summary.noGeometry", {smart_count:noGeometryTotal})}
                    </div>}
                {noRelatedAttributeTotal > 0 && <div>
                        <LocationNotRelated color="disabled" />
                        {translate("resources.geometry.summary.noRelatedAttribute", {smart_count:noRelatedAttributeTotal})}
                    </div>}
                {notFoundTotal > 0 && <div>
                        <LocationNotFound color="error" />
                        {translate("resources.geometry.summary.notFound", {smart_count:notFoundTotal})}
                    </div>}
                {!addedTotal && !noGeometryTotal && !noRelatedAttributeTotal && !notFoundTotal && <div>
                        {translate("resources.geometry.summary.nothing")}
                    </div>}
                <Row noClone className="bar">
                    <Spacing />
                    <Button variant="outlined" label="resources.close" onClick={() => {setOpen(false)}}></Button>
                    <Spacing />
                </Row>
            </div>
        </Dialog>
    </>
};

export default GeometryImportButton;